import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function driverLicenseNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const regex = /^[A-Za-z]{1,2}\d{6,7}[A-Za-z]?$|^[A-Za-z]\d{7}[A-Za-z]?$/;
    const value = control.value.trim();

    const isLengthValid = value.length === 7 || value.length === 8;

    const isFormatValid = regex.test(value);

    if (isLengthValid && isFormatValid) {
      return null;
    }

    return { 'invalidDriverLicense': true };
  };
}
